import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-schedule-dialog',
  templateUrl: './schedule-dialog.component.html',
  styleUrls: ['./schedule-dialog.component.scss']
})
export class ScheduleDialogComponent implements OnInit {

  date: Date | null = null;
  time: string = '';

  constructor(private dialogRef: MatDialogRef<ScheduleDialogComponent>) {}

  ngOnInit(): void {}

  confirm() {
    if (this.date && this.time) {
      const [hours, minutes] = this.time.split(':').map(Number);
      const scheduledDate = new Date(this.date);
      scheduledDate.setHours(hours, minutes, 0);
      const timestamp = scheduledDate.getTime();
      this.dialogRef.close(timestamp);
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

}
